import { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import {  TOAST_PROPERTIES } from './toastProperties';
import './Toast.css';
import userContext from '../../context/users/UserContext';

const Toast = props => {
    const {showSuccessToast,setSuccessToast} = useContext(userContext);
    const [tempToastList,setToastList] = useState([]);
    let autoDeleteTime = 2000;
    let autoDelete = true;
    if(props.autoDeleteTime != undefined || props.autoDeleteTime != null){
        autoDeleteTime = props.autoDeleteTime
    }
    if(props.autoDelete != undefined || props.autoDelete != null){
        autoDelete = props.autoDelete
    }
    const { text,state } = props;
    const [list, setList] = useState(tempToastList);

    useEffect(() => {
        setList([...tempToastList]);
    }, [tempToastList]);

    useEffect(()=>{
        const toastProperties = TOAST_PROPERTIES.find((toast) => toast.title.toLowerCase() === state);
        setToastList([...tempToastList,toastProperties])
    },[])

    useEffect(() => {
        const interval = setInterval(() => {
            if (autoDelete && tempToastList.length && list.length) {
                deleteToast(tempToastList[0].id);
            }
        }, autoDeleteTime);
        
        return () => {
            clearInterval(interval);
        }
    }, [tempToastList, autoDelete, autoDeleteTime, list]);

    const deleteToast = id => {
        const listItemIndex = list.findIndex(e => e.id === id);
        const toastListItem = tempToastList.findIndex(e => e.id === id);
        list.splice(listItemIndex, 1);
        tempToastList.splice(toastListItem, 1);
        setList([...list]);
        setSuccessToast(false);
    }

    return (
        <>
            <div id="toast-parent" className={`notification-container bottom-right `}>
                {
                   list.length>0 && list.map((toast, i) =>     
                        <div 
                            key={i}
                            className={`notification toast bottom-right`}
                            style={{ backgroundColor: toast.backgroundColor }}
                        >
                            
                            <div className="notification-image">
                                <img src={toast.icon} alt="" />
                            </div>
                            <div style={{flex:"10", marginRight: "10px"}}>
                                <p className="notification-title" style={{ color: toast.color }}>{text}</p>
                                {/* <p className="notification-message">
                                    {toast.description}
                                </p> */}
                            </div>
                            <button onClick={() => deleteToast(toast.id)}>
                                    <img src={toast.cancelIcon} alt="" />
                            </button>
                        </div>
                    )
                }
            </div>
        </>
    );
}

Toast.propTypes = {
    text: PropTypes.string,
    autoDelete: PropTypes.bool,
    autoDeleteTime: PropTypes.number
}

export default Toast;